export const uuid = () => (Math.random() + 1).toString(36).substring(2);
